export default __webpack_public_path__ + "rj.jpg?49ebe15470a813dd11916af83190fc44";